import React from 'react';
import StoreManagement from '../../../components/Stores';

function StoresPage() {
  return <StoreManagement />;
}

export default StoresPage;
